import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e39da3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex-1 tw-w-full tw-px-2 tw-pb-2 tw-flex tw-flex-col tw-gap-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-component p-card p-card-title tw-w-full tw-bg-gray-50 tw-rounded tw-p-2" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.5rem","font-weight":"700"} }, "Guardia Virtual")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "p-component p-card tw-bg-gray-50 card-demanda-virtual tw-flex-1 tw-overflow-auto tw-flex tw-w-full tw-bg-transparent tw-rounded tw-border tw-shadow"
}
const _hoisted_4 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_5 = { class: "tw-w-full tw-flex tw-flex-1 tw-flex-1 p-3" }
const _hoisted_6 = {
  key: 0,
  class: "tw-flex-1 tw-bg-primary tw-rounded tw-overflow-hidden"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-relative"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"icon-container tw-p-8\" data-v-2e39da3d><svg width=\"4rem\" height=\"4rem\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2e39da3d><g id=\"Waiting_Area\" data-name=\"Waiting Area\" data-v-2e39da3d><path d=\"m47 30h-4a1 1 0 0 0 0 2h1v7h-5v-1a3 3 0 0 0 0-6h-2v-1a5 5 0 0 0 4.73-5.28l-.61-9.88a3 3 0 0 0 -3-2.81h-10.24a3 3 0 0 0 -3 2.81l-.61 9.88a5 5 0 0 0 4.73 5.28v1h-2a3 3 0 0 0 0 6v1h-6v-1a3 3 0 0 0 0-6h-2v-1a5 5 0 0 0 4.73-5.28l-.61-9.88a3 3 0 0 0 -3-2.81h-10.24a3 3 0 0 0 -3 2.81l-.61 9.88a5 5 0 0 0 4.73 5.28v1h-2a3 3 0 0 0 0 6v1h-5v-7h1a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2h1v8a1 1 0 0 0 1 1h4v5h-4a1 1 0 0 0 0 2h43a1 1 0 0 0 0-2h-5v-5h4a1 1 0 0 0 1-1v-8h1a1 1 0 0 0 0-2zm-20.74-4.19.62-9.87a1 1 0 0 1 1-.94h10.24a1 1 0 0 1 1 .94c.88 14.65 2.28 13.06-9.86 13.06a3 3 0 0 1 -3-3.19zm4.74 5.19h4v1h-4zm-4 3h12a1 1 0 0 1 0 2h-12a1 1 0 0 1 0-2zm2 4h8v1h-8zm-20.74-12.19.62-9.87a1 1 0 0 1 1-.94h10.24a1 1 0 0 1 1 .94c.64 10.28 1 10.84-.19 12.11s-2 .95-9.67.95a3 3 0 0 1 -3-3.19zm4.74 5.19h4v1h-4zm-4 3h12a1 1 0 0 1 0 2h-12a1 1 0 0 1 0-2zm2 4h8v1h-8zm28 8h-30v-5h30z\" data-v-2e39da3d></path><path d=\"m42 12a6 6 0 1 0 -6-6 6 6 0 0 0 6 6zm0-10a4 4 0 1 1 -4 4 4 4 0 0 1 4-4z\" data-v-2e39da3d></path><path d=\"m42.79 8.21a1 1 0 0 0 1.42-1.42l-1.21-1.2v-1.59a1 1 0 0 0 -2 0c0 2.94-.33 2.08 1.79 4.21z\" data-v-2e39da3d></path></g></svg></div>", 1)
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = { class: "tw-text-3xl tw-font-bold" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("personas en espera ")
const _hoisted_15 = {
  key: 0,
  class: "tw-text-sm"
}
const _hoisted_16 = { class: "tw-font-semibold" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_18 = {
  key: 1,
  class: ""
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Para continuar con la recepción deberá abonar el siguiente importe ")
const _hoisted_22 = { class: "tw-font-bold" }
const _hoisted_23 = {
  class: "tw-flex tw-flex-col tw-gap-3 tw-h-full",
  style: {"aspect-ratio":"1/.6","min-height":"10rem"}
}
const _hoisted_24 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.turnoRecepcionado)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.urlLLamadaVirtual)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("iframe", {
                      allowfullscreen: "",
                      sandbox: "allow-scripts allow-presentation allow-same-origin allow-downloads",
                      allow: "autoplay; camera; microphone; web-share; fullscreen; picture-in-picture; xr-spatial-tracking; clipboard-write; downloads;",
                      type: "text/html",
                      class: "tw-w-full tw-h-full",
                      src: _ctx.urlLLamadaVirtual,
                      frameborder: "0"
                    }, null, 8, _hoisted_7)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelarCita && _ctx.cancelarCita(...args))),
                      class: "tw-top-0 tw-right-0 tw-absolute tw-cursor-pointer tw-underline tw-text-primary"
                    }, "Cancelar"),
                    _hoisted_9,
                    (_ctx.counterAndTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.counterAndTime?.count), 1),
                          _hoisted_12,
                          _hoisted_13,
                          _hoisted_14,
                          (_ctx.counterAndTime.count)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createTextVNode("Sera " + _toDisplayString(_ctx.sexoPaciente[0] === 'F' ? 'atendida' : 'atendido') + " en aprox. ", 1),
                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.counterAndTime?.time), 1),
                                _hoisted_17
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, "En unos instantes será " + _toDisplayString(_ctx.sexoPaciente[0] === 'F' ? 'atendida' : 'atendido') + ".", 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          class: "tw-my-auto animate",
          style: {"max-width":"25rem"}
        }, _createSlots({
          title: _withCtx(() => [
            (!_ctx.turnoAPagar)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Nueva Atención"))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, "Abonar Atención"))
          ]),
          content: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Dropdown, {
                onChange: _cache[1] || (_cache[1] = ()=>{}),
                class: "tw-w-full",
                showClear: "",
                modelValue: _ctx.servicioSeleccionado,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.servicioSeleccionado) = $event)),
                options: _ctx.serviciosVirtuales,
                optionLabel: "descripcion",
                placeholder: "Servicio",
                filterPlaceholder: "Buscar.."
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_Button, {
                label: "Entrar en Guardia",
                class: "tw-w-full tw-mt-auto",
                onClick: _ctx.handleSolicitarCita
              }, null, 8, ["onClick"])
            ], 512), [
              [_vShow, !_ctx.turnoAPagar]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Button, {
                label: "Abonar con Mercado Pago",
                icon: "pi pi-external-link",
                iconPos: "right",
                onClick: _ctx.pagarTurno
              }, null, 8, ["onClick"]),
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelarCita && _ctx.cancelarCita(...args))),
                class: "tw-cursor-pointer tw-underline tw-text-primary"
              }, "Cancelar")
            ], 512), [
              [_vShow, _ctx.turnoAPagar]
            ])
          ]),
          _: 2
        }, [
          (_ctx.turnoAPagar)
            ? {
                name: "subtitle",
                fn: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _hoisted_21,
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.toIntlNumberFormat(_ctx.turnoAPagar?.metadata?.paymentInfo?.amount || 0)), 1)
                  ])
                ])
              }
            : undefined
        ]), 1024))
  ]))
}